export const locale = {
    lang: 'vi',
    data: {
        MENU: {
            ACTIONS: 'Hoạt động',
            CREATE_POST: 'Tạo bài viết mới ',
            PAGES: 'Trang ',
            FEATURES: 'Đặc trưng ',
            DASHBOARD: 'Bảng xếp hạng thành tích',
            PROJECTS: 'Danh sách dự án ',
            RECENT_PROJECTS: 'Dự án gần đây ',
            DIRECT_CHAT: 'Trò chuyện trực tiếp',
            LATEST_UPDATES: 'Bản cập nhật mới nhất ',
            HOME: 'Trang chủ',
            CHAT_GROUPS: 'Nhóm chat ',
            FILES: 'Tệp',
            SCHEDULE: 'Lịch dự án ',
            GANTT_CHART: 'Lịch dự án ',
            PROJECT_SETTINGS: 'Cài đặt dự án',
            SPACE_MANAGEMENT: 'Cài đặt Spaces',
            TEAM_MANAGEMENT: 'Cài đặt Team ',
            SYSTEM_MANAGEMENT: 'Cài đặt hệ thống',
            SPACE_SETTINGS: 'Tùy chỉnh Spaces',
            TEAM_SETTINGS: 'Tùy chỉnh Team ',
            LANGUAGE_AND_TIME_SETTINGS: 'Cài đặt ngôn ngữ và thời gian ',
            USERS: 'Tài khoản ',
            SPACES: 'Danh sách khách hàng ',
            TEAMS: 'Team ',
            JAPAN_TEAM: 'Japan Teams',
            JAPAN_TEAM_LIST: 'Japan Team List',
            OVERSEAS_TEAM: 'Overseas Teams',
            OVERSEAS_TEAM_LIST: 'Overseas Team List',
            MY_SETTINGS: 'Cài đặt của tôi ',
            USER_INFO: 'Thông tin tài khoản  ',
            EMAIL: 'Email',
            PASSWORD: 'Mật khẩu',
            ORDER: 'Đặt hàng ',
            TEAM_ORDER: 'Dự án mới ',
            PRIVACY_POLICY: 'Chính sách bảo mật',
            TERMS_OF_SERVICE: 'Điều khoản dịch vụ  ',
            COMPANY: 'Order Go! Tokyo STUDIO55, Inc. All Rights Reserved.',
            SEARCH_RESULTS: 'Menu tìm kiếm - kết quả ',
            CLIENT: 'Client',
            CUSTOMER: 'khách hàng',
            READ_ALL: 'READ ALL',
            SEARCH_LATEST_CHANGES: "Search latest changes..."
        },
        AUTH: {
            GENERAL: {
                OR: 'Hoặc ',
                SUBMIT_BUTTON: 'Nộp ',
                NO_ACCOUNT: 'Bạn không có tải khoản? ',
                SIGNUP_BUTTON: 'Đăng kí ',
                FORGOT_BUTTON: 'Quên mật khẩu ',
                SAVE_BUTTON: 'Lưu mật khẩu',
                BACK_BUTTON: 'Quay lại',
                PRIVACY: 'Quyền riêng tư',
                LEGAL: 'Pháp lý ',
                CONTACT: 'Liên hệ',
                LOGOUT: 'Thoát',
                SAVE_NOTIFICATION: 'Đã lưu thông tin tài khoản '
            },
            LOGIN: {
                TITLE: 'Đăng nhập ',
                BUTTON: 'Đăng nhập ',
            },
            FORGOT: {
                TITLE: 'Bạn quên mật khẩu?',
                DESC: 'Nhập email để cài đặt lại mật khẩu',
                SUCCESS: 'Thảnh công! Bạn đã đặt lại mật khẩu của mình'
            },
            REGISTER: {
                TITLE: 'Đăng kí ',
                DESC: 'Nhập thông tin cá nhân để tạo tài khoản',
                SUCCESS: 'Tài khoản của bạn đã được tạo thành công'
            },
            INPUT: {
                EMAIL: 'Email ',
                FULLNAME: 'Tên đầy đủ',
                PASSWORD: 'Mật khẩu ',
                CONFIRM_PASSWORD: 'Xác nhận lại mật khẩu ',
                USERNAME: 'Tên tài khoản'
            },
            VALIDATION: {
                INVALID: '{{name}} không khả dụng',
                REQUIRED: '{{name}} yêu cầu nhập',
                MIN_LENGTH: '{{name}} độ dài tối thiểu  {{min}} ',
                AGREEMENT_REQUIRED: 'Cần đồng ý điều khoản và điều kiện sử dụng',
                NOT_FOUND: '{{name}} không tìm thấy tài khoản này ',
                INVALID_LOGIN: 'Thông tin đăng nhập không đúng',
                REQUIRED_FIELD: 'Thông tin yêu cầu ',
                MIN_LENGTH_FIELD: 'Độ dài tối thiều:',
                MAX_LENGTH_FIELD: 'Độ dài tối đa:',
                INVALID_FIELD: 'Không khả dụng',
            }
        },
        PROJECTS: {
            PROJECTS_LIST: 'Danh sách dự án',
            PROJECT_HOME: 'Trang dự án ',
            LATEST_CHANGES: 'Thay đổi mới nhất ',
            CHAT_GROUPS: 'Nhóm chat ',
            FILES: 'Tệp',
            SCHEDULE: 'Lịch dự án ',
            GANTT_CHART: 'Lịch dự án ',
            SETTINGS: 'Cài đặt',
            DELETE_USER: 'Xóa tài khoản ',
            EDIT_FILE: 'Chỉnh sửa tệp ',
            DELETE_FILE: 'Xóa tệp',
            DELETE_PROJECT: {
                TITLE: 'Xóa dự án ',
                DESCRIPTION: 'Bạn có chắc bạn muốn xóa dự án này không?',
                WAIT_DESCRIPTION: 'Đang xóa dự án ',
                MESSAGE: 'Dự án đã được xóa '
            },
            RESTORE_PROJECT: {
                TITLE: 'khôi phục dự án',
                DESCRIPTION: 'Bạn có chắc bạn muốn xóa dự án này không?',
                WAIT_DESCRIPTION: 'Đang xóa dự án ',
                MESSAGE: 'Dự án đã được xóa '
            },
            DELETE_MULTIPLE_PROJECTS: {
                TITLE: 'Xóa dự án ',
                DESCRIPTION: 'Bạn có chắc bạn muốn xóa dự án này không?',
                WAIT_DESCRIPTION: 'Đang xóa',
                MESSAGE: 'Dự án này đã được xóa'
            },
            ADD_SCHEDULE_BUTTON: 'Thêm lịch dự án ',
            EXPORT_TO_PDF: 'Xuất sang PDF',
            EXPORT_TO_PDF_MOBILE: 'PDF',
            SAVE: 'Lưu',
            CANCEL: 'Hủy',
            CLOSE: 'Close',
            DONE: 'Đã xong',
            PERMISSION: 'Cho phép',
            RESET: 'Thiết lập lại',
            INFO: 'Thông tin dự án',
            NAME: 'Tên dự án',
            START_DATE: 'Start Date',
            SCHEDULED_DELIVERY_DATES: 'Scheduled delivery date',
            DELIVERY_DATES: 'Ngày nộp dự án',
            SUB: 'Chọn loại phụ',
            SUB_TYPE: 'Sub Type',
            SUB_TYPE_CAMERA: 'Camera Angle',
            SUB_TYPE_SOFTWARE: 'Software',
            SUB_TYPE_ANIMATION: 'Production Seconds',
            USER: 'Tài khoản',
            ADD_USER: 'Thêm tài khoản',
            PROJECT_NAME_ERROR: 'プロジェクト名が同じではありません。',
            PROJECT_NAME_REQUIRED: 'プロジェクト名が必要です。',
            PROJECT_SEARCH: {
                PROJECT_NAME: 'Tên dự án',
                FROM_DELIVERY_DATE: 'Tử ngày nộp dự án',
                TO_DELIVERY_DATE: 'Đến ngày nộp dự án ',
                FROM_CREATION_DATE: 'Từ ngày tạo dự án ',
                TO_CREATION_DATE: 'Đến ngày tạo dự án',
                APPLY_FILTERS: 'Áp dụng bộ lọc',
                SORT_CATEGORY: 'Sắp xếp theo nhóm ',
                SORT_TYPE: 'Sắp xếp theo loại ',
            },
            SCHEDULED_DATE_OF_DELIVERY: 'Scheduled date of delivery',
            DATE_OF_DELIVERY: 'Date Of Delivery',
            CREATED_BY: 'Created By',
            PRICE: 'Price',
            MODIFIED_AT: 'Modified At',
            MENU: 'Menu',
            COMMENT_ON_DELIVERY: 'Comment',
            ADDITIONAL_URLS: 'Additional URLs',
            BACK_TO_CHAT_ROOM: 'Back to the chat room',
        },
        PROJECT_MANAGEMENT: {
            ATTACHED_FILES: 'Đính kèm ',
            MESSAGE_PLACEHOLDER: 'Hãy nhập tin nhắn...'
        },
        ZOOM: {
            MEETING: 'Cuộc họp ZOOM',
            START_MEETING: 'Cuộc họp ZOOM bắt đầu',
            TOPIC: 'đề tài',
            CANCEL: 'Hủy',
            CREATE: 'tạo nên',
            WAITING: 'Cuộc họp ZOOM này vẫn chưa bắt đầu. Bạn có muốn bắt đầu?',
            STARTED: 'Cuộc họp ZOOM này đang được tổ chức. Bạn có chắc chắn muốn tham gia không?',
            ENDED: 'Cuộc họp ZOOM này đã kết thúc.',
            TOPIC_REQUIRED: 'Chủ đề bắt buộc',
        },
        GENERAL: {
            FORM_ERROR: 'Xảy ra lỗi khi nhập thông tin. Hãy gửi lại sau khi kiềm tra',
            DUPLICATE_USER_ERROR: 'The provided email is already registered. Please use a different email or use the password restore service.',
            DUPLICATE_EMAIL_ERROR: 'The provided email is already registered. Please use a different email.',
            SEARCH: 'Tìm kiếm ',
            SELECTED_RECORDS_COUNT: 'Đã chọn',
            CUSTOMER_SUFFIX: '',
            CALENDAR_DAY_0: 'SUN',
            CALENDAR_DAY_1: 'MON',
            CALENDAR_DAY_2: 'TUE',
            CALENDAR_DAY_3: 'WED',
            CALENDAR_DAY_4: 'THU',
            CALENDAR_DAY_5: 'FRI',
            CALENDAR_DAY_6: 'SAT',
        },
        SCHEDULES:{
            EDIT_SCHEDULE:{
                UPDATE_MESSAGE: 'Task Edited Successfully.',
                ADD_MESSAGE: 'Task Added Successfully.'
            }
        },
        CONVERSATIONS: {
            ADD_BUTTON: 'Thêm nhóm chat mới ',
            USER_NAME: 'Tên tài khoản ',
            CONVERSATIONS_LIST: 'Danh sách nhóm chat ',
            CONVERSATIONS_HOME: '',
            SUBJECT: 'Chủ đề ',
            SUBJECT_ERROR: 'Bạn cần nhập chủ đề',
            ACTIONS: 'Hoạt động',
            VIEW_CONVERSATION: '',
            EDIT_CONVERSATION: {
                TITLE: 'Chỉnh sửa nhóm chat',
                UPDATE_MESSAGE: 'Cập nhập nhóm chat',
                ADD_MESSAGE: 'Thêm nhóm chat'
            },
            DELETE_CONVERSATION: {
                TITLE: 'Xóa nhóm chat',
                DESCRIPTION: 'Bạn có chắc bạn muốn xóa nhóm chat này không?',
                WAIT_DESCRIPTION: 'Đang xóa ',
                MESSAGE: 'Nhóm chat đã được xóa'
            },
            DELETE_PRIVATE_CONVERSATION: {
                TITLE: 'Delete private chat group',
                DESCRIPTION: 'Are you sure you want to delete this private chat?',
                WAIT_DESCRIPTION: 'Deleting the private chat...',
                MESSAGE: 'private chat was deleted'
            },
            MEMBERS: 'Thành viên nhóm chat',
            PRIVATE_CHAT: 'Private chat',
            PRIVATE_CHAT_REGISTERED: '(Registered)',
            ADD_USER: 'Thêm người dùng',
            FILE_NAME: 'Tên tệp',
            NO_DATA_DESCRIPTION: 'Không tìm thấy dữ liệu ',
            NEW_ANNOTATION: 'Một chú thích mới đã được thêm vào tệp',
            SYSTEM_MESSAGE: 'System Message',
            CHECK_ESTIMATE_TITLE: 'please check estimate',
            CHECK_ESTIMATE_DESCRIPTION: 'Is the above estimated amount all right?',
            CHECK_ESTIMATE_PENDING: 'Estimate under confirmation',
            CHECK_ESTIMATE_ACCEPT: 'YES',
            CHECK_ESTIMATE_ACCEPTED: 'We received an agreement on the estimated amount.',
            CHECK_ESTIMATE_REJECT: 'NO',
            CHECK_ESTIMATE_REJECTED: 'We will consider the contents of the quotation again.',
            FINAL_VERSION_DESCRIPTION: '※The project will be completed when the delivery is OK.<br />※Select NO for correction.',
            FINAL_VERSION_ACCEPT_MESSAGE: 'Delivery is complete.',
            FINAL_VERSION_REJECT_MESSAGE: 'Delivery is incomplete.',
            CHECK_SCHEDULE: 'Check Schedule',
            FULL_SIZE_IMAGE_DOWNLOAD: 'Download full size image',
            FINAL_VERSION_TITLE: 'Final Version',
            FINAL_VERSION_PENDING: 'Pending Confirmation',
            FINAL_VERSION_ACCEPT: 'Accept as Final Version',
            FINAL_VERSION_ACCEPTED: 'Accepted as Final Version',
            FINAL_VERSION_REJECT: 'Reject as Final Version',
            FINAL_VERSION_REJECTED: 'Rejected as Final Version',
            WITHOUT_AUTOMATIC_TRANSLATIONS: 'Automatic translations (disabled)',
            WITH_AUTOMATIC_TRANSLATIONS: 'Automatic translations (enabled)',
            CONVERSATION_NAME: 'Chat Group',
            CREATED_AT: 'Created At',
            FILE_UPLOAD: 'File Upload',
            LIBRARY: 'Library',
            CROP_TOOL: 'Crop Tool',
            EMOJI: 'Emoji',
            AI_GENERATE: "AI Generate",
            ZOOM: 'Zoom',
            AUTO_SCROLL_IS_DISABLED: 'Auto scrolling is disabled',
            SYSTEM_MESSAGE_CREATE_PROJECT: '<p>From ORDER GO!</p><p>Thank you for joining for ORDER GO!</p><p>The person in charge will contact you via this chat today, so please be patient.</p><p>If we contact you via this chat, you will also be alerted to your ORDER GO! Registration email.</p><p class="kt-chat__description">The order reception time is from 11:00 AM to 8:00 PM.<br />Please note that we will contact you today during the order reception time.<br />If it is outside the order reception time, we will contact you tomorrow.</p>',
            SYSTEM_MESSAGE_CONFIRM_ESTIMATE: '<p>Thank you for your order.</p><p>The director in charge of production will contact you via this chat, so please be patient.</p><p class="kt-chat__description">※If we contact you via this chat, you will also be alerted to your ORDER GO! Registration email.</p>',
            SYSTEM_MESSAGE_REJECT_ESTIMATE: '<p>Please wait for a while as the sales representative will contact you again.</p><p>If we contact you via this chat, you will also be alerted to your ORDER GO! Registration email.</p><p class="kt-chat__description">※Business hours AM11: 00 ~ PM8: 00<br />※Please note that we will contact you tomorrow if it is outside business hours.</p>',
            SYSTEM_MESSAGE_CONFIRM_FINAL_VERSION: '<p>Thank you for confirming delivery.</p><p>This case is completed here.</p><p>Thank you for your order.</p><p class="kt-chat__description">※Please let us know if there is a correction again.</p>',
            SYSTEM_MESSAGE_REJECT_FINAL_VERSION: '<p>Thank you for your confirmation.</p><p>Please check back on the image again and the director in charge of production will contact you on this chat so please wait for a while.</p>',
            SYSTEM_MESSAGE_SEND_SCHEDULE: '<p>Please check that we have entered the production schedule.</p><p class="kt-chat__description">※Please let us know if there is any inconvenience in the checkback schedule.</p>',
            SYSTEM_MESSAGE_ADD_ANNOTATION: '<p>Thank you for checking back.</p><p>We will proceed with the production here.</p><p class="kt-chat__description">Depending on the content of the correction, the director in charge of production may ask you a question.</p>',
        },
        MESSAGES: {
            SAVE_ANGLE: 'Lưu Angle',
            ADD_ANGLE: 'Add Angle',
            RESTORE_ANGLE: 'Restore Angle',
            DELETE_ANGLE: 'Delete Angle',
            DESCRIPTION_ANGLE_TOOL: 'Click the save button when you find an angle that interests you and comment.',
            DELETE_MESSAGE: {
                TITLE: 'Xóa tin nhắn',
                DESCRIPTION: 'Bạn có chắc bạn muốn xóa tin nhắn này không?',
                WAIT_DESCRIPTION: 'Đang xóa ',
                MESSAGE: 'Tin nhắn đã được xóa'
            },
            IMAGE_TOOL: 'Image Review Tool',
            DESCRIPTION_IMAGE_TOOL: 'Use the image annotation tools below to highlight or comment on what interests you.',
            ANGLE_REVIEW_TOOL: 'Angle Review Tool'
        },
        MY_SETTINGS: {
            MY_SETTINGS: 'Cài đặt của tôi ',
            USER_INFO: 'Thông tin tài khoản ',
            EMAIL: 'Email',
            PASSWORD: 'Mật khẩu ',
            SAVE_PASSWORD: 'Change Password',
            SAVE: 'Lưu ',
            RESET: 'Thiết lập lại',
            CREATE_USER: 'Tạo tài khoản ',
            EDIT_USER: 'Chỉnh sửa tài khoản ',
            USER_DETAIL: {
                EMAIL: 'Email ',
                USER_NAME: 'Tên tài khoản ',
                ICON: 'Hình đại diện ',
                BACKGROUND_PIC: 'Hình nền',
                SELECT_IMAGE: 'Chọn ảnh',
                LANGUAGE: 'Ngôn ngữ ',
                TIMEZONE: 'Múi giờ ',
                USER_GROUP: 'User Group',
                USER_GROUP_NAME: 'User Group Name',
                USER_GROUP_NAME_REQUIRED: 'User Group Name Required.',
                SELECT_USER_GROUP: 'Select User Group',
                ROLE: 'Chức danh',
                STANDARD_IMAGE: 'Hình mặc định ',
                STANDARD_IMAGE_DESCRIPTOPN: 'Mở cửa sổ chọn hình đại diện ',
                OPEN_BACKGROUND_IMAGE_SELECTION_SCREEN: 'Open background selection screen',
                ORIGINAL_IMAGE: 'Hình ảnh gốc',
                ORIGINAL_IMAGE_DESCRIPTOPN: 'Chọn file ',
                IMAGE_DESCRIPTION: 'Hình ảnh sẽ tự động giảm chất lượng nếu độ phân giải quá 100x100',
                LANGUAGE_DESCRIPTION: "Cài đặt riêng sẽ được ưu tiên nếu có. ",
                TIMEZONE_DESCRIPTION: "Thời gian hết hạn sẽ được xét theo múi giờ "
            },
            EMAIL_DETAIL: {
                EMAIL: 'Email',
                RECIEVE_EMAIL: 'Nhận email ',
                RECIEVE_MYREPORT: 'Nhận báo cáo của tôi ',
                RECIEVE_SETTINGS: 'Không thêm "Tạo mới", "Bình luận", "Đã xong", "Thay đổi liên hệ" trong chủ đề email',
                RECIEVE_SETTINGS_DESCRIPTION: '(Nếu sử dụng Gmail, tất cả email về một chủ đề phải được hiển thị thành 1 chuỗi email)',
                PROJECT: 'Email dự án',
                ISSUE: 'Vấn đề ',
                RECEPTION_TIMING: 'Thời gian nhận ',
                LIMIT_ISSUE: 'Hạn chế thời gian nhận ',
                NOTIFICATION: 'Thông báo ',
                PROJECT_REPORT: 'Báo cáo dự án',
                ADD: 'Khi thêm hoặc cập nhật',
                COMMENT: 'Khi thêm bình luận 時',
                All: 'Nhận tất cả vấn đề',
                CHARGE: 'Tôi chịu trách nhiệm ',
                REGISTERED: 'Tôi đăng kí',
                ALWAYS_RECEIVE: 'Luôn nhận thông báo liên quan đến bạn',
                RECEIVE_PROJECT_REPORT: 'Nhận báo cáo dự án',
                GENERAL_SETTING: 'Cài đặt chung ',
                GENERAL_SETTING_DESCRIPTION: 'Cài đặt chung (Dự án không có cài đặt riêng sẽ dùng cài đặt chung này)'
            },
            DELETE_USER_MODAL: {
                TITLE: 'Xóa tài khoản ',
                DESCRIPTION: 'Bạn có chắc bạn muốn xóa tài khoản này vĩnh viễn không?？',
                WAIT_DESCRIPTION: 'Đang xóa',
                DELETE_MESSAGE: 'Tài khoản đã được xóa'
            },
            DELETE_TEAM_MODAL: {
                TITLE: 'Xóa Team',
                DESCRIPTION: 'Bạn có chắc bạn muốn xóa Team này vĩnh viễn không?',
                WAIT_DESCRIPTION: 'Đang xóa',
                DELETE_MESSAGE: 'Team đã được xóa'
            },
            DELETE_SPACE_MODAL: {
                TITLE: 'Xóa Space ',
                DESCRIPTION: 'Bạn có chắc bạn muốn xóa Space này vĩnh viễn không?',
                WAIT_DESCRIPTION: 'Đang xóa Space',
                DELETE_MESSAGE: 'Space đã được xóa'
            },
            DELETE_SUUMO_SPACE_MODAL: {
                TITLE: 'Delete SUUMO Space(s)',
                DESCRIPTION: 'Are you sure you want to permanently delete SUMMO Space(s)?',
                WAIT_DESCRIPTION: 'Deleting SUUMO Space(s)...',
                DELETE_MESSAGE: 'SUUMO Space(s) Deleted.'
            },
            DELETE_USER_GROUP_MODAL: {
                TITLE: 'Delete User Group(s)',
                DESCRIPTION: 'Are you sure you want to permanently delete User Group(s)?',
                WAIT_DESCRIPTION: 'Deleting User Group(s)...',
                DELETE_MESSAGE: 'User Group(s)... Deleted'
            },
            PASSWORD_DETAIL: {
                EMAIL: 'Email',
                USER_NAME: 'Tên tài khoản ',
                PASSWORD: 'Mật khẩu ',
                CURRENT_PASSWORD: 'Mật khẩu hiện tại ',
                NEW_PASSWORD: 'Mật khẩu mới ',
                CONFIRM_PASSWORD: 'Xác nhận lại mật khẩu '
            },
            VALIDATION_ERROR_MESSAGE: 'Hãy điền vào những thông tin sau: {{fields}}'
        },
        SPACE_MANAGEMENT: {
            SPACE_SETTINGS: 'Cài đặt Spaces',
            CUSTOMER_SETTINGS: 'Cài đặt khách hàng',
            SPACE_INFO: 'Thông tin Spaces',
            CUSTOMER_INFO: 'Customer info',
            LANGUAGE_AND_TIME_SETTINGS: 'Cài đặt ngôn ngữ và thời gian',
            USERS: 'Tài khoản ',
            PROJECTS: 'Danh sách dự án ',
            SAVE: 'Lưu',
            RESET: 'Thiết lập lại',
            BACK: 'Quay lại',
            REQUEST_ADD_USER: 'Request',
            ACTIONS: 'Hoạt động ',
            EDIT_USER: 'Chỉnh sửa tài khoản ',
            DELETE_USER: 'Xóa tài khoản ',
            EDIT_PROJECT: 'Chỉnh sửa dự án',
            DELETE_PROJECT: 'Xóa dự án ',
            GENERAL_INFORMATION: 'Thông tin tổng quát',
            PASSWORD: 'Mật khẩu',
            SETTINGS_DETAIL: {
                SPACE_NAME: 'Tên Space:',
                SPACE_PLACEHOLDER: 'Tên Space',
                EDIT_SPACE: 'Chỉnh sửa Space',
                ADMINISTRATOR: 'Studio 55 Sales Manager',
                CUSTOMER_NAME: 'Customer Name'
            },
            LANGUAGE_AND_TIME_SETTINGS_DETAIL: {
                LANGUAGE_AND_TIME_SETTINGS: 'Cài đặt ngôn ngữ và thời gian',
                LANGUAGE: 'Ngôn ngữ ',
                LANGUAGE_DESCRIPTION: 'Cài đặt riêng sẽ được ưu tiên nếu có. ',
                TIMEZONE: 'Múi giờ ',
                TIMEZONE_DESCRIPTION: 'Thời gian hết hạn sẽ được xét theo múi giờ ',
            },
            USERS_DETAIL: {
                ADD: 'Thêm tài khoản ',
                USERNAME: 'Tên tài khoản ',
                EMAIL: 'Email',
                AUTHORITY: 'Chức danh ',
                COMPANY_NAME: 'Tên công ty '
            },
            ADD_SPACE_BUTTON_TEXT: 'Thêm Space',
            RESET_SPACE_BUTTON_TEXT: 'Thiết lập lại',
            SAVE_SPACE_BUTTON_TEXT: 'Lưu ',
            LIST_OF_SPACE: 'Danh sách Space ',
            LIST_OF_CUSTOMER: 'Customer List',
            LIST_OF_USER_GROUP: 'User Group List',
        },
        TEAM_MANAGEMENT: {
            TEAM_SETTINGS: 'Cài đặt Team ',
            TEAM_INFO: 'Chỉnh sửa Team ',
            TEAM_NAME: 'Tên Team ',
            LANGUAGE_AND_TIME_SETTINGS: 'Cài đặt ngôn ngữ và thời gian ',
            SAVE: 'Lưu ',
            RESET: 'Thiết lập lại',
            BACK: 'Quay lại ',
            ACTIONS: 'Hoạt động',
            EDIT_USER: 'Chỉnh sửa tài khoản ',
            DELETE_USER: 'Xóa tài khoản ',
            EDIT_TEAM: 'Chỉnh sửa Team ',
            USERS: 'Danh sách thành viên ',
            PROJECTS: 'Danh sách dự án ',
            EDIT_PROJECT: 'Chỉnh sửa dự án ',
            DELETE_PROJECT: 'Xóa dự án',
            GENERAL_INFORMATION: 'Thông tin tổng quát',
            PASSWORD: 'Mật khẩu',
            SETTINGS_DETAIL: {
                TEAM_NAME: 'Tên Team',
                TEAM_PLACEHOLDER: 'Tên Team',
                TEAM_TYPE:'チームの種類'
            },
            LANGUAGE_AND_TIME_SETTINGS_DETAIL: {
                LANGUAGE_AND_TIME_SETTINGS: 'Cài đặt ngôn ngữ và thời gian',
                LANGUAGE: 'Ngôn ngữ',
                LANGUAGE_DESCRIPTION: 'Cài đặt riêng sẽ được ưu tiên nếu có.',
                TIMEZONE: 'Múi giờ',
                TIMEZONE_DESCRIPTION: 'Thời gian hết hạn sẽ được xét theo múi giờ',
            },
            USERS_DETAIL: {
                ADD: 'Thêm tài khoản',
                USERNAME: 'Tên tài khoản',
                EMAIL: 'Email',
                AUTHORITY: 'Chức danh'
            },
            ADD_TEAM_BUTTON_TEXT: 'Thêm Team',
            RESET_TEAM_BUTTON_TEXT: 'Thiết lập lại',
            SAVE_TEAM_BUTTON_TEXT: 'Lưu',
            LIST_OF_TEAM: 'Danh sách Team ',
            GANTT_CHART: 'Lịch dự án '
        },
        SYSTEM_MANAGEMENT: {
            TITLE: 'Quản lí hệ thống',
            TEAMS: 'Danh sách Team',
            SPACES: 'Danh sách khách hàng',
            SYSTEMS: 'Danh sách hệ thống',
            USERS: 'Danh sách tài khoản',
            SYSTEM_SETTINGS: 'Cài đặt hệ thống',
            SYSTEM_INFO: 'Thông tin hệ thống',
            USER_GROUP_INFO: 'User Group Info',
            USER_GROUP_NAME: 'User Group Name',
            ADD_USER_GROUP: 'Add user group',
            USER_GROUP_USERS: 'Affiliated users',
            LANGUAGE_AND_TIME_SETTINGS: 'Cài đặt ngôn ngữ và thời gian',
            PROJECTS: 'Dự án',
            SAVE: 'Lưu',
            RESET: 'Thiết lập lại',
            BACK: 'Quay lại',
            ACTIONS: 'Hoạt động',
            EDIT_USER: 'Chỉnh sửa tài khoản',
            DELETE_USER: 'Xóa tài khoản',
            EDIT_PROJECT: 'Chỉnh sửa tài khoản',
            DELETE_PROJECT: 'Xóa tài khoản',
            RESTORE_PROJECT: 'khôi phục dự án',
            GENERAL_INFORMATION: 'Thông tin tổng quát',
            PASSWORD: 'Mật khẩu',
            COMPANY_NAME: 'Tên công ty',
            CUSTOMER_SPACE: 'Tên khách hàng',
            TEAM: 'STUDIO 55 Team',
            SETTINGS_DETAIL: {
                SPACE_NAME: 'Tên khách hàng',
                SPACE_PLACEHOLDER: 'Tên khách hàng',
                EDIT_SPACE: 'Chỉnh sửa khách hàng',
            },
            LANGUAGE_AND_TIME_SETTINGS_DETAIL: {
                LANGUAGE_AND_TIME_SETTINGS: 'Cài đặt ngôn ngữ và thời gian',
                LANGUAGE: 'Ngôn ngữ:',
                LANGUAGE_DESCRIPTION: 'Cài đặt riêng sẽ được ưu tiên nếu có.',
                TIMEZONE: 'Múi giờ:',
                TIMEZONE_DESCRIPTION: 'Thời gian hết hạn sẽ được xét theo múi giờ ',
            },
            USERS_DETAIL: {
                ADD: 'Thêm tài khoản',
                USERNAME: 'Tên tài khoản',
                EMAIL: 'Email',
                AUTHORITY: 'Chức danh'
            },
            ADD_SPACE_BUTTON_TEXT: 'Thêm khách hàng',
            RESET_SPACE_BUTTON_TEXT: 'Thiết lập lại',
            SAVE_SPACE_BUTTON_TEXT: 'Lưu',
            LIST_OF_SPACE: 'Danh sách khách hàng',
        },
        USER_MANAGEMENT: {
            TITLE: 'Quản lí hệ thống',
            TEAMS: 'Danh sách Team',
            SPACES: 'Danh sách khách hàng',
            USERS: 'Danh sách người dùng',
            ADD_USER_BUTTON_TEXT: 'Thêm người dùng',
            BACK_USER_BUTTON_TEXT: 'Quay lại',
            SAVE_USER_BUTTON_TEXT: 'Lưu',
            LIST_OF_USER: 'Danh sách người dùng',
        },
        NEW_PROJECT_WIZARD: {
            TITLE: 'Đặt hàng',
            SELECT_TYPE: 'Chọn loại',
            SUB_TYPE_SELECTION: 'Chọn loại',
            SUB_TYPE_SELECTION_CAMERA: 'Select camera angle',
            SUB_TYPE_SELECTION_SOFTWARE: 'Select software',
            SUB_TYPE_SELECTION_ANIMATION: 'Select production seconds',
            REQUIRED: '*',
            DOCUMENT_UPLOAD: 'Upload dữ liệu',
            SCHEDULED_DELIVERY_DATES: 'Scheduled delivery date',
            DELIVERY_DATES: 'Ngày giao hàng mong muốn',
            COMPLETE: 'Gửi tất cả',
            SELECT_DESCRIPTION: 'Hãy chọn từ những loại sau',
            STATUS: 'Trạng thái',
            PERTH: 'Ảnh CG tĩnh',
            CG: 'Ảnh CG tĩnh',
            VR: 'VR・AR・MR',
            BAVR: 'BAVR (Before & After VR)',
            ANIMATION: 'Animation',
            ANIMATION_TIME: 'Seconds',
            OTHER: 'その他',
            FROM_TIME: 'Từ thời gian',
            TO_TIME: 'Đến thời gian ',
            BIM: 'Mô hình BIM',
            SKETCHUP: 'Sketch Up',
            ENSCAPE: 'Enscape',
            SHAPESPARK: 'Shapespark',
            TWINMOTION: 'Twinmotion',
            FIXED_POINT_PANORAMA: 'Fixed point panorama VR',
            PANORAMA: 'パノラマ写真',
            REVIT: 'Revit',
            ARCHI_CAD: 'Archi CAD',
            IF_CG_IS_SELECTED: '<strong> Vật liệu yêu cầu trong CG: </strong><ul><li> Bản vẽ mặt bằng mặt đứng</li> <li> Bản vẽ triển khai, vv. (Bản vẽ thể hiện các thông tin chi tiết như chiều cao,...)</li> <li> Bản vẽ chiếu sáng</li> <li>  Bản vẽ cảnh quan</li> <li> Hình ảnh đồ nội thất và đèn </li> <li>',
            IF_VR_IS_SELECTED: '<strong> Vật liệu yêu cầu trong VR </strong> <ul><li> Bản vẽ mặt bằng mặt đứng</li><li> Bản vẽ triển khai, vv. (Bản vẽ thể hiện các thông tin chi tiết như chiều cao,...)</li><li> Thông tin khu đất </li><li> Bản vẽ chiếu sáng</li><li> Thông tin vật liệu hoàn thiện</li><li> Thông tin loại cây và đồ nội thất </li><li> Phạm vi chế tác </li></ul>\'',
            IF_ANIMATION_IS_SELECTED: '<strong> Vật liệu yêu cầu trong Animation</strong> <ul><li> Chỉ thị đường đi</li><li> Bản vẽ mặt bằng</li><li> Bản vẽ triển khai, vv. (Bản vẽ thể hiện các thông tin chi tiết như chiều cao,...)</li><li> Hình ảnh đèn, đồ nội thất</li><li> Thông tin vật liệu hoàn thiện（Hình ảnh vật liệu hay mã số vật liệu của nhà sản xuất）</li><li> Độ dài cần thực hiện</li></ul>',
            IF_BIM_IS_SELECTED: '<strong> Vật liệu yêu cầu trong mô hình BIM</strong> <ul><li> Bản vẽ mặt bằng</li><li> Bản vẽ triển khai, vv. (Bản vẽ thể hiện các thông tin chi tiết như chiều cao,...)</li><li> Bản vẽ cảnh quan</li><li> Bản vẽ chiếu sáng</li><li>Thông tin vật liệu hoàn thiện</li><li> Thông tin loại cây và đồ nội thất</li></ul>',
            COMMENT_ON_DELIVERY: 'Hãy viết bình luận ở đây',
            SUB_TYPE_SELECTION_DESCRIPTION1: 'Hãy chọn từ những loại sau',
            SUB_TYPE_SELECTION_DESCRIPTION2: 'Sau khi chọn loại, hãy điền vào số lượng mong muốn hoặc nhấn vào "-" và "+".',
            PROJECT_NAME: 'Tên dự án',
            TYPE: 'Type',
            SOFTWARE: 'Phần mềm',
            SHORT_TIME: '0 phút ~ 5 phút',
            MEDIUM_TIME: '5 phút ~ 10 phút',
            LONG_TIME: '10 phút ~ 15 phút',
            APPEARANCE: 'Ngoại thất',
            INSIDE_VIEW: 'Nội thất',
            AERIAL_VIEW: 'Phối cảnh chim bay',
            COMMENT: 'Bình luận',
            DOCUMENT_UPLOAD_DESCRIPTION1: 'Hãy thả tệp hay upload tệp bằng nút "Chọn tệp"',
            DOCUMENT_UPLOAD_DESCRIPTION2: '* Hãy gom file cần thiết vào file ZIP',
            DOCUMENT_UPLOAD_DESCRIPTION3: 'Thả tệp ở đây',
            DOCUMENT_UPLOAD_DESCRIPTION4: 'Hoặc',
            DOCUMENT_UPLOAD_DESCRIPTION5: 'またはファイルのURLを記入してください',
            DOCUMENT_UPLOAD_DESCRIPTION6: '* Bạn có thể upload dữ liệu kể cả sau khi đặt chỗ, hoặc muốn bổ sung thêm dữ liệu.',
            CHOICE_FILE: 'Chọn tệp',
            NECESSARY_FILES: 'Danh sách tệp cần thiết',
            NECESSARY_FILES_DESCRIPTION: 'Hãy chắc chắn là bạn đã check vào mục trong danh sách bên dưới',
            LESS: 'Hoặc ít hơn',
            CAN_UPLOAD: 'Tệp có thể upload',
            CAN_UPLOAD_DESCRIPTION1: 'Không cài mật khẩu vào tệp cần upload, nếu cần thay đổi xin hãy upload lại.',
            CAN_UPLOAD_DESCRIPTION2: "\"/: *?\" <> | \"Không thể sử dụng những kí tự này trong tên file. <br> Những kí tự này sẽ tự động được thay thế nếu sử dụng",
            PREFERRED_DATE: 'Ngày giao mong muốn',
            PREFERRED_TIME: 'Thời gian giao mong muốn',
            START_DATE: 'Start Date',
            TEN_TO_TWELVE: '10:00 ~ 12:00',
            TWELVE_TO_SIXTEEN: '12:00 ~ 16:00',
            SIXTEEN_TO_NINETEEN: '16:00 ~ 19:00',
            NINETEEN_TO_TWENTYFOUR: '19:00 ~ 24:00',
            TWELVE_TO_SEVENTEEN: '12:00 ~ 17:00',
            SEVENTEEN_TO_TWENTY: '17:00 ~ 20:00',
            ADDITIONAL_DESCRIPTION_WARNING: 'The desired delivery date can be selected from a business days (weekdays only). If you wish to select a weekend delivery date, please select the nearest weekday and use the comments field.',
            ADDITIONAL_DESCRIPTION: 'Trong những trường hợp sau chi phí và thời gian sản xuất có thể khác, xin hãy liên hệ riêng cho chúng tôi.',
            HURRY: 'Dự án gấp. Thiếu bản vẽ',
            NIGHT_VIEW: 'Bối cảnh vào hoàng hôn hay ban đêm',
            HIGH_QUALITY: 'Chất lượng cao',
            COMPLETE_DESCRIPTION1: 'Đơn đặt hàng của bạn đã được gửi đi',
            COMPLETE_DESCRIPTION2: 'Xin hãy chờ người phụ trách liên hệ lại với bạn',
            BACK: 'Quay lại',
            NEXT: 'Tiếp theo',
            SAVE: 'Lưu',
            BACK_TO_DASHBOARD: 'Quay lại Dashboard',
            DATA_SUBMISSION_CONVERSATION: 'Gửi dữ liệu',
            DATA_SUBMISSION_MESSAGE: 'Gửi dữ liệu',
            TIME: 'Time',
            LOGIN_PERMISSION: 'Login Permission',
            DISABLED: 'Disabled',
            ENABLED: 'Enabled',
            VRARMR: 'VR・AR・MR',
            UNITY: 'Unity',
            UNREAL: 'Unreal',
            IF_SELECTED: 'If the above materials are insufficient, please proceed to the next step.<br />You can upload the material later.',
            IF_NOT_SELECTED: 'There are no required files.',
            DOCUMENT_URL_PLACEHOLDER: 'If you use ファイル便, please enter the URL',
            ADDITIONAL_DESCRIPTION_ABOUT_DAY_AND_TIME: 'Please select the start date, delivery date, and delivery time from the calendar.',
            ADDITIONAL_DESCRIPTION_ABOUT_DAY: 'Please select the desired delivery date from the right.',
            ADDITIONAL_DESCRIPTION_ABOUT_TIME: 'If you have a desired time, please select from the desired delivery time.',
            ADDITIONAL_DESCRIPTION_ABOUT_COMMENT: 'If you have any other comments, please write them in the comments section.',
            COMPLETE_ADDITIONAL_DESCRIPTION1: '※The order has not started at this point.',
            COMPLETE_ADDITIONAL_DESCRIPTION2: '※There is no charge.',
            PROJECT_PROGRESS_GROUP_CONVERSATION: 'Project progress group',
        },
        PRIVACY_POLICY: {
            TITLE: '個人情報保護方針',
            OVERVIEW_DESCRIPTION1: 'STUDIO55,Inc.（以下「当社」といいます）は、お客様が安心して弊社サービスをご利用することができるよう、事業活動を通じて取得するお客様の個人情報の保護に細心の注意を払っています。お客様の個人情報を保護することは、当社の事業活動の基本であるとともに、当社の社会的責務であると考えております。 当社は責任をもってお客様の個人情報を保護するため、当社が取り扱う個人情報の公正かつ適正な管理、運用について規定を定め、社内体制の構築、施策の実施・維持、それらの継続的な改善を行っています。',
            OVERVIEW_DESCRIPTION2: '1.　当社は、すべての事業で取扱う個人情報および従業員等の個人情報の取扱いに関し、個人情報の保護に関する法律（平成15年法律第57号。以下「法」といいます。）その他関連法令、国が定める指針その他の規範を遵守いたします。',
            OVERVIEW_DESCRIPTION3: '2.　当社は、「個人情報の取扱い」記載のとおり、個人情報の取得、利用にあたっては、その利用目的を特定することとし、特定された利用目的の達成に必要な範囲を超えた個人情報の取扱い（目的外利用）はいたしません。また、目的外利用を行わないために、適切な管理措置を講じます。',
            OVERVIEW_DESCRIPTION4: '3.　当社は、「個人情報の取扱い」記載のとおり、ご本人の同意を得ている場合、法令にもとづく場合等を除き、取得した個人情報を第三者に提供することはいたしません。',
            OVERVIEW_DESCRIPTION5: '4.　当社は、個人情報の取扱いに関する苦情および相談を受けた場合は、その内容について迅速に事実関係等を調査し、合理的な期間内に誠意をもって対応いたします。',
            OVERVIEW_DESCRIPTION6: '5.　当社は、取得した個人情報を適切に管理するため、組織的・人的・物理的・技術的な安全対策措置を講じ、個人情報の漏えい、滅失またはき損の防止および是正に取り組みます。',
            OVERVIEW_DESCRIPTION7: '6.　当社は、社会情勢・環境の変化を踏まえて、継続的に個人情報保護に関する個人情報保護マネジメントシステムを見直し、個人情報保護への取り組みを改善していきます。',
            ESTABLISHMENT: '制定：?年?月?日',
            COMPANY: 'STUDIO55,Inc. 代表取締役社長　?',
            PERSONAL_INFORMATION: '個人情報の取扱い',
            ARTICLE1: '第１条　取得する個人情報',
            ARTICLE1_DESCRIPTION1: '当社は、法に基づき、下記の個人情報を取得いたします',
            ARTICLE1_DESCRIPTION2: '（1） サービスへのログインおよび利用等に関する情報',
            ARTICLE1_DESCRIPTION3: "・サービスログインのためのアカウントのIDおよびパスワード<br>\n" +
                "\t\t\t・アカウント登録情報としての氏名、企業名、電話番号、メールアドレス<br>\n" +
                "\t\t\t・アカウントに紐づく情報としてお客様から提供される氏名、企業名、電話番号、メールアドレス、その他のお客様に関する情報<br>\n" +
                "\t\t\t・サービスの利用を通じてお客様が行った取引の遂行のための情報および当該取引内容に関する情報<br>\n" +
                "\t\t\t・クレジットカード情報、銀行口座情報に関する情報その他の決済およびその方法に関する情報<br>\n" +
                "\t\t\t・サービスの投稿機能を利用してお客様から提供される画像、文章、コメント等の投稿コンテンツに関する情報<br>\n" +
                "\t\t\t・お客様から当社へのお問い合わせやご連絡等に関する情報",
            ARTICLE1_DESCRIPTION4: '（2） お客様が使用する端末に関する情報およびCookie等を利用して取得する情報',
            ARTICLE1_DESCRIPTION5: '・情報通信端末の機体識別に関する情報<br>\n' +
                '\t\t\t・情報通信端末のOS情報<br>\n' +
                '\t\t\t・インターネットへの接続に関する情報<br>\n' +
                '\t\t\t・位置情報<br>\n' +
                '\t\t\t・リファラー情報<br>\n' +
                '\t\t\t・IPアドレス情報<br>\n' +
                '\t\t\t・閲覧したURLおよび閲覧した日時に関するタイムスタンプ情報<br>\n' +
                '\t\t\t・サービスの利用に関する情報<br>\n' +
                '\t\t\t・お客様の端末ごとに割り振られる広告識別子情報<br>\n' +
                '\t\t\t・サーバログ情報',
            ARTICLE1_DESCRIPTION6: '（3） 従業員等に係る情報',
            ARTICLE1_DESCRIPTION7: '・従業員（派遣職員、アルバイトを含みます。）の氏名、住所、来歴その他の従業員に係る情報<br>\n' +
                '\t\t\t・当社の取引先等の個人に係る情報',
            ARTICLE1_DESCRIPTION8: '（4） 第三者から取得する情報',
            ARTICLE1_DESCRIPTION9: '・お客様の同意を得て第三者から取得する情報<br>\n' +
                '\t\t\t・法令に基づき取得する情報<br>\n' +
                '\t\t\t・公開されていることにより取得する情報',
            ARTICLE2: '第２条　個人情報の利用目的',
            ARTICLE2_DESCRIPTION1: '当社は、第１条に記載した個人情報を、法に基づき、下記の目的の範囲内で共同利用いたします。',
            ARTICLE2_DESCRIPTION2: '（1） サービスへのログインおよびサービスの利用',
            ARTICLE2_DESCRIPTION3: '・お客様がサービスにログインするため<br>\n' +
                '\t\t\t・お客様に適したサービスを提供するため<br>\n' +
                '\t\t\t・お客様と当社との間の取引の成立および履行その他のお客様によるサービスの利用のため<br>\n' +
                '\t\t\t・サービスの会員であるお客様の管理のため<br>\n' +
                '\t\t\t・サービスの対価の請求のため<br>\n' +
                '\t\t\t・サービスの運営上必要な事項の通知のため<br>\n' +
                '\t\t\t・サービスの各種問合わせ、アフターサービス対応のため<br>\n' +
                '\t\t\t・退会したお客様へのご連絡・各種問合わせ対応のため<br>\n' +
                '\t\t\t・不正行為等の防止および対応のため',
            ARTICLE2_DESCRIPTION4: '（2） 広告・マーケティング',
            ARTICLE2_DESCRIPTION5: '・サービス上または第三者の媒体においてサービスの勧誘、広告その他のマーケティングをするため\n' +
                '\t\t\t・メールマガジンの送信のため\n' +
                '\t\t\t・ダイレクトメールの送付のため\n' +
                '\t\t\t・キャンペーン、懸賞企画、アンケートの実施のため',
            ARTICLE2_DESCRIPTION6: '（3） 商品開発・研究',
            ARTICLE2_DESCRIPTION7: '・マーケティングデータの調査・分析のため<br>\n' +
                '\t\t\t・当社の新たなサービスや商品等の開発のため',
            ARTICLE2_DESCRIPTION8: '（4） 個人情報保護方針',
            ARTICLE2_DESCRIPTION9: '・採用・労務・退職者その他の当社の労務管理のため<br>\n' +
                '\t\t\t・取引先情報の管理のため',
            ARTICLE3: '第２条　個人情報の利用目的',
            ARTICLE3_DESCRIPTION1: '第３条　個人情報の提供の同意',
            ARTICLE3_DESCRIPTION2: '当社は、法令で認められる場合またはお客様の同意をいただいた場合には第三者に対して個人情報を提供いたします。ただし、以下の場合においては、当社は第三者に対して、必要な範囲で個人情報（第１号および第２号にあっては，氏名や住所など直接特定の個人を識別することができる情報を除外した情報）を提供させていただきます。',
            ARTICLE3_DESCRIPTION3: '（1） サービスの提供または品質向上に必要な場合',
            ARTICLE3_DESCRIPTION4: '（2） 新たなサービスの検討・開発のために必要な場合',
            ARTICLE3_DESCRIPTION6: '（3） 外国にある第三者に個人情報の取り扱いを委託する場合',
            ARTICLE4: '第４条　Order Go!の特則',
            ARTICLE4_DESCRIPTION1: '当社が運営するOrder Go!については、次の規定が適用されます。',
            ARTICLE4_DESCRIPTION2: '（1） お客様の情報の公開',
            ARTICLE4_DESCRIPTION3: '① お客様のOrder Go! IDは、Order Go!を提供するウェブサイト上に表示され 全てのお客様に対して公開されることになります。 また、お客様が投稿したコンテンツは、Order Go!において 公開設定を行うことにより同じく公開されることになります。',
            ARTICLE4_DESCRIPTION4: '② お客様は、Order Go!の機能を利用して、 第三者サイトとOrder Go!とをリンクさせた場合、 第三者サイトにおいてOrder Go!上で公開されている情報全部または 一部が公開されることになります。',
            ARTICLE4_DESCRIPTION5: '③ 当社は、Order Go!の利用を通じた情報の公開に起因してお客様に何らかの損害または損失が発生したとしても、故意または重過失がない限り、当該損害または損失に対し一切の責任を負いません。',
            ARTICLE4_DESCRIPTION6: '（2） サービスの終了と情報の取扱い',
            ARTICLE4_DESCRIPTION7: '① お客様がOrder Go!から退会する手続を完了した場合、 または当社がお客様をOrder Go!から退会させた場合、当社は、Order Go!上におけるお客様の情報の公開を速やかに停止致します。ただし、当該停止時点で既に他のお客様との間でやり取りされたメッセージまたは 共有機能を通して提供されている情報については、 公開停止処理後であっても一部公開状態が継続される可能性があります。',
            ARTICLE4_DESCRIPTION8: '② 前項の公開停止後といえども、当社は、関連する適用法令に従い、お客様の情報のアーカイブを正当な事業上の目的のため必要最低限の範囲内において、当社の技術上合理的なセキュリティが確保された保管方法にて継続して保有することができるものとします。',
            ARTICLE5: '第６条　開示、訂正等の手続きについて',
            ARTICLE5_DESCRIPTION1: '当社は、ご本人からの開示対象個人情報の開示、利用目的の通知、開示対象個人情報の内容が事実に反する場合等における訂正等、利用停止等および第三者提供の停止（以下「開示等」という。）のご請求を受付いたします。',
            ARTICLE5_DESCRIPTION2: 'https://www.google.com/intl/ja/policies/privacy/partners/',
            ARTICLE6: '第５条　Googleアナリティクスの利用について',
            ARTICLE6_DESCRIPTION1: '当社は、ご本人からの開示対象個人情報の開示、利用目的の通知、開示対象個人情報の内容が事実に反する場合等における訂正等、利用停止等および第三者提供の停止（以下「開示等」という。）のご請求を受付いたします。',
            ARTICLE6_DESCRIPTION2: '（1） 開示等の求めの申し出先',
            ARTICLE6_DESCRIPTION3: '郵送でご請求いただく場合は、第７条の規定の宛先に所定の請求書に必要書類を添付のうえ、ご郵送ください。',
            ARTICLE6_DESCRIPTION4: '（2） ご提出いただくもの',
            ARTICLE6_DESCRIPTION5: '① 個人情報利用目的の通知・開示請求書',
            ARTICLE6_DESCRIPTION6: '② 個人情報訂正等請求書',
            ARTICLE6_DESCRIPTION7: '③ 個人情報利用停止等請求書',
            ARTICLE6_DESCRIPTION8: '④ 本人確認のための書類（運転免許証、パスポートなど）',
            ARTICLE6_DESCRIPTION9: '⑤ 法定代理人の場合は、上記④　に加え、法定代理権があることを確認する書類',
            ARTICLE6_DESCRIPTION10: '（3） 手数料',
            ARTICLE6_DESCRIPTION11: '当該ご請求のうち、開示のご請求および利用目的の通知のご請求につきましては、１回のご請求につき、1,000円の手数料をご負担いただきますので、あらかじめご了承ください。なお、郵送でご請求いただく場合は、振込み等により、手数料をいただきます。 開示等のご請求の具体的な手続きにつきましては、第８条の窓口までお問い合わせください。',
            ARTICLE7: '第７条　個人情報の取扱いに関するご相談・苦情について',
            ARTICLE7_DESCRIPTION11: '当社の個人情報の取扱いに関するご相談や苦情等のお問い合わせについては、下記の窓口までご連絡いただきますよう、お願い申し上げます。。',
            CONTACT: '［個人情報についてのお問い合わせ先］<br>\n' +
                '\t\t\t〒???-????<br>\n' +
                '\t\t\t?<br>\n' +
                '\t\t\t?<br>\n' +
                '\t\t\tSTUDIO55,Inc.<br>\n' +
                '\t\t\t営業時間　/　?：?～?：?'
        },
        TERMS_AND_CONDITIONS: {
            TITLE: '利用規約',
            OVERVIEW_DESCRIPTION1: '1. STUDIO55,Inc.（以下、「当社」といいます。）は、サービスである「Order Go!」（以下、単に「Order Go!」といいます。）、その他今後当社が新しく開始するサービス（以下、個別に「各サービス」といいます。）及び共通サービスの利用規約（以下、「本規約」といいます。）を以下の通り定めます。',
            OVERVIEW_DESCRIPTION2: '2. 各サービスを利用される場合は、各サービスに関する利用規約のみが適用となりますので、その場合は当社が別途定める各サービスに関する利用規約にそれぞれ従うものとします。',
            OVERVIEW_DESCRIPTION3: '共通サービス利用規約',
            CHAPTER1: '第1章 総則',
            ARTICLE1: '第1条 本規約の範囲及び変更',
            ARTICLE1_DESCRIPTION1: '1. 本規約は、当社が運営するウェブサイトに共通するサービス（以下、「本サービス」といいます。）の利用に関する規約を定めたものです。',
            ARTICLE1_DESCRIPTION2: '2. 本規約は、本サービスの利用に関して、利用者（第3条で定義します。）全てに適用されるものとします。 但し、本サービス以外の当社が提供する各サービスに関して、各サービスに関する利用規約にのみ定めのある規定、又は関連する項目で本規約と各サービスに関する利用規約との間で重複する規定がある場合には、各サービスに関する利用規約の規定のみが適用されます。',
            ARTICLE1_DESCRIPTION3: '3. 当社は、利用者の事前の承諾を得ることなく、サイト上での掲載又はメール等の当社が適当と判断する方法で利用者に告知又は通知することにより、適宜、本規約の全部又は一部を変更できるものとします。',
            ARTICLE1_DESCRIPTION4: '4. 本規約の全部又は一部が変更された場合、本サービスの利用に関しては、変更後の規約が適用されるものとし、利用者は変更後の規約のみに従うものとします。',
            ARTICLE1_DESCRIPTION5: '',
            ARTICLE2: '第2条 本サービスの利用',
            ARTICLE2_DESCRIPTION1: '利用者は、法令、規則、通達並びに本規約及び当社が別途定める個人情報保護方針、ヘルプ等に従い、本サービスを利用するものとします。',
            CHAPTER2: '第2章 利用者',
            ARTICLE3: '第3条 利用者',
            ARTICLE3_DESCRIPTION1: '本規約において「利用者」とは、本規約の内容を全て了解・承認した上で、当社が本サービスで提供する画像、テキスト、デザイン、ロゴ、映像、プログラム、アイディア、情報等（以下、本規約において「コンテンツ」と総称します。）を検索、閲覧又は利用する者（会員（＜共通サービス利用規約＞第4条で定義します。）を含みます。）を総称します。',
            CHAPTER3: '第3章 会員',
            ARTICLE4: '第4条 会員',
            ARTICLE4_DESCRIPTION1: '本規約において「会員」とは、本規約の内容を全て了解・承認した上で、当社所定の手続に従い会員登録を申請し、当社がこれを承認した者、並びに会員登録をおこなわずに、商品購入のたびに当社が別途指定する必要事項を入力し、当社がこれを承認した者を総称します。',
            ARTICLE5: '第5条 会員登録',
            ARTICLE5_DESCRIPTION1: '1. 会員登録の希望者は、本サービスの会員登録ページから、当社が別途指定する方法に従い、氏名、企業名、電話番号、メールアドレス、パスワード、また当社を通じて商品又はサービス（以下、「商品等」と総称します。）を購入する際には、住所、氏名、電話番号、企業名を設定・入力の上、会員登録申請を行うものとします。',
            ARTICLE5_DESCRIPTION2: '2. 当社は、第1項に基づく申請に対し、パソコン、タブレット端末並びにスマートフォンからの会員登録の場合、会員登録ボタンを押した時点で会員登録を承認するものとします。',
            ARTICLE5_DESCRIPTION3: '3. 当社は、以下の各号の何れかに該当する場合、当該登録を承認しないものとします。',
            ARTICLE5_DESCRIPTION4: '(1) 会員登録の希望者が、過去に当社の提供する何らかのサービスに関する規約（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）に違反したこと等により、会員登録の抹消等の処分を受けていたことが判明した場合',
            ARTICLE5_DESCRIPTION5: '(2) 会員登録の希望者が、過去に当社の提供する何らかのサービスに関する規約（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）に違反したこと等により、会員登録の抹消等の処分を受けていたことが判明した場合',
            ARTICLE5_DESCRIPTION6: '(3) 会員登録の希望者が、過去に当社の提供する何らかのサービス（サイト上に明記した各サービスに関連する他社のサービスを含みますが、これらに限りません。）に関して、料金等（商品等の購入代金を含みますが、これに限りません。以下同様とします。）の支払を履行していない場合（当社が別途認める支払方法に関連する第三者に対して料金等の支払を履行していない場合を含みますが、これに限りません。）、又は、正当な理由なく長期間に亘る商品等の受取り不能、返品・交換の拒絶その他の債務不履行があったことが判明した場合',
            ARTICLE5_DESCRIPTION7: '(4) 過去に本規約第14条（禁止事項）の行為を行ったことが判明した場合',
            ARTICLE5_DESCRIPTION8: '(5) その他登録を承認することが本サービスの運営・管理上、不適当であると当社が合理的に判断する場合',
            ARTICLE5_DESCRIPTION9: '',
            ARTICLE6: '第6条 登録内容の変更',
            ARTICLE6_DESCRIPTION1: '1. 会員は、当社に登録している事項の全部又は一部に変更が生じた場合には、当社が指定する方法により、すみやかに登録内容を変更するものとします。',
            ARTICLE6_DESCRIPTION2: '2. 当社は、利用者が適宜、変更登録を行わなかったことにより何らかの損害が生じたとしても、一切責任を負わないものとします。',
            ARTICLE7: '第7条 本サービスの利用停止及び会員登録の取消',
            ARTICLE7_DESCRIPTION1: '当社は、会員が以下の各号の何れかに該当する場合、事前に通知することなく、当該会員に対して本サービスの利用停止、会員登録抹消その他当社が適当と考える措置を講ずることができるものとします。',
            ARTICLE7_DESCRIPTION2: '(1) 過去に当社の提供する何らかのサービスに関する規約に違反をしたこと等により、会員登録の抹消等の処分を受けていたことが判明した場合',
            ARTICLE7_DESCRIPTION3: '(2) 登録された内容に虚偽の事項が含まれていることが判明した場合',
            ARTICLE7_DESCRIPTION4: '(3) 過去又は現在において、当社の提供する何らかのサービスに関して、料金等の支払を履行していない場合（当社が別途認める支払方法に関連する第三者に対して料金等の支払を履行していない場合を含みますが、これに限りません。）、又は、正当な理由なく長期間に亘る商品等の受取り不能、返品・交換の拒絶その他の債務不履行 があったことが判明した場合',
            ARTICLE7_DESCRIPTION5: '(4) 過去に本規約第14条（禁止事項）の行為を行ったことが判明した場合',
            ARTICLE7_DESCRIPTION6: '(5) その他当社が定める何らかの規約（本規約を含みますが、これに限りません。）の規定に違反した場合',
            ARTICLE8: '第8条 退会手続',
            ARTICLE8_DESCRIPTION1: '会員は、当社所定の手続を経て、退会することができるものとします。契約月が月初となる為、翌月退会される場合は当月中に退会手続きを行ってください。（例）５月１日から利用されない場合、４月３０日までに退会手続きを行ってください。また、契約期間の途中の解約や利用日数の有無にかかわらず、当社が規定した契約期間分の料金は、全額お支払いいただくものとし、既にお支払いいただいた利用料金がある場合でも当社から会員（契約者）への返金は致しません。',
            ARTICLE9: '第9条 ID及びパスワードの管理',
            ARTICLE9_DESCRIPTION1: '1. 会員は、会員登録等の際に会員自身で設定したメールアドレス及びパスワードを厳重に管理・保管する責任を負うものとします。',
            ARTICLE9_DESCRIPTION2: '2. 会員は、当社の事前の同意がある場合を除き、メールアドレス及びパスワードを第三者に譲渡、売買、承継、貸与、開示又は漏洩してはならないものとします。',
            ARTICLE9_DESCRIPTION3: '3. 会員は、メールアドレス又はパスワードが第三者によって不正に使用されていることが判明した場合には、直ちに当社に連絡するものとし、当社の指示がある場合はそれに従うものとします。',
            ARTICLE9_DESCRIPTION4: '4. 会員は、メールアドレス又はパスワードの管理不十分、使用上の過誤・不手際、第三者の無断使用等に起因する損害につき自ら責任を負うものとし、当社は一切責任を負担しないものとします。',
            ARTICLE10: '第10条 個人情報の利用',
            ARTICLE10_DESCRIPTION1: '本サービスの利用に関連して当社が知り得た会員の個人情報については、当社は別途当社が定める「個人情報保護方針」に従い取り扱うものとします。',
            CHAPTER4: '第4章 サービスの利用',
            ARTICLE11: '第11条 提供するサービス',
            ARTICLE11_DESCRIPTION1: '当社は、本サービスの一部として次のサービスを提供します。',
            ARTICLE11_DESCRIPTION2: '(1) 会員がマイページ（第12条で定義します。）を利用すること',
            ARTICLE11_DESCRIPTION3: '(2) 各サービスを横断して検索すること',
            ARTICLE11_DESCRIPTION4: '(3) 各サービスの情報を閲覧すること',
            ARTICLE11_DESCRIPTION5: '(4) 各サービスからのリンク先を閲覧すること',
            ARTICLE12: '第12条 コンソールの利用',
            ARTICLE12_DESCRIPTION1: '会員は、当社所定のコンソールを利用することができます。コンソールは、本サービスにログインしているメールアドレスの会員の購入、登録、設定・閲覧機能として、会員自身が設定もしくは購入したデバイス、キャラクター、背景、AIサービス、プロフィール、インサイトを設定、登録・閲覧できる機能を提供しています。',
            ARTICLE13: '第13条 免責事項',
            ARTICLE13_DESCRIPTION1: '1. 本サービスから他のウェブサイト若しくはリソースへのリンク、又は第三者のウェブサイト若しくはリソースから本サービスへのリンクを提供している場合、当社は、当該リンク先の内容、利用及びその結果（適法性、有効性、正確性、確実性、安全性、最新性及び完全性を含みますが、これらに限られません。）については、いかなる責任も負わないものとします。なお、当社は、リンク先のウェブサイト又はリソースの内容が、違法又は本サービスの管理・運営上不適切であると合理的に判断した場合には、会員に何らの通知を要することなく、当該リンク先を削除することができるものとします。',
            ARTICLE13_DESCRIPTION2: '2. 本サービス中に広告（懸賞広告を含みますが、これに限りません。）又は宣伝を行っている広告主との取引（懸賞等のプロモーションへの参加を含みますが、これに限りません。）がある場合、利用者は、自らの判断と責任により、当該広告主との間で取引を行うものであり、これに関して当社は一切責任を負わないものとします。商品等の代金の支払、契約条件の決定、保証、担保責任、ライセンスの有無等の取引に関する内容・条件は、一切、当社が保証するものではなく、当社は、本サービス中に掲載されている広告又は宣伝を経由して行われる取引に起因して、会員に何らかの損害については一切責任を負わないものとします。',
            ARTICLE13_DESCRIPTION3: '3. 当社は、以下の場合に、一時的に本サービスが停止、中止又は変更されたとしても、会員が直接的又は間接的に被った一切の損害、損失、不利益等について、いかなる責任も負わないものとします。',
            ARTICLE13_DESCRIPTION4: '(1) 火災、地震、洪水、落雷、大雪等の天変地異が生じた場合',
            ARTICLE13_DESCRIPTION5: '(2）戦争、内乱、テロ、暴動、騒乱等の社会不安が生じた場合',
            ARTICLE13_DESCRIPTION6: '(3) 当社が契約している電話会社、運送会社又はプロバイダから適切なサービスを受けられなかった場合',
            ARTICLE13_DESCRIPTION7: '(4) 当社が技術的に対応不可能な事由が生じた場合',
            ARTICLE13_DESCRIPTION8: '4. 当社は、会員の登録内容に従い事務を処理することにより、当社の債務を履行し免責されるものとします。',
            ARTICLE13_DESCRIPTION9: '5. 会員が、本サービスを利用することにより、他の利用者又は第三者に対して何らかの損害等を与えた場合には、当該会員はその責任と費用においてこれを解決し、当社には一切の損害、損失、不利益等を与えないものとします。',
            ARTICLE14: '第14条 禁止事項',
            ARTICLE14_DESCRIPTION1: '利用者は、以下の行為を一切行ってはならないものとします。万一、これに違反して当社又は第三者に損害が生じた場合、当該利用者がその損害を全て賠償する責任を負うものとします。',
            ARTICLE14_DESCRIPTION2: '(1) 他の利用者、他の利用者以外の第三者、若しくは当社に迷惑、不利益若しくは損害を与える行為、又はそれらのおそれのある行為',
            ARTICLE14_DESCRIPTION3: '(2) 他の利用者、他の利用者以外の第三者、若しくは当社の著作権等の知的財産権、肖像権、人格権、プライバシー権、パブリシティ権その他の権利を侵害する行為又はそれらのおそれのある行為',
            ARTICLE14_DESCRIPTION4: '(3) 本サービスを商業目的で利用する行為（但し、当社が予め認めたものは除きます。）',
            ARTICLE14_DESCRIPTION5: '(4) 公序良俗に反する行為その他法令に違反する行為又はそれらのおそれのある行為',
            ARTICLE14_DESCRIPTION6: '(5) 虚偽又は誤解を招くような内容を含む情報を登録する行為',
            ARTICLE14_DESCRIPTION7: '(6) 本サービスを通じて入手したコンテンツを利用者が私的使用の範囲外で使用する行為（但し、当社が予め認めたものは除きます。）',
            ARTICLE14_DESCRIPTION8: '(7) 他の利用者、又は他の利用者以外の第三者を介して、本サービスを通じて入手したコンテンツを複製、販売、出版、頒布、公開及びこれらに類似する行為（但し、当社が予め認めたものは除きます。）',
            ARTICLE14_DESCRIPTION9: '(8) 他の利用者の個人情報を収集、蓄積又は保存をする行為',
            ARTICLE14_DESCRIPTION10: '(9) コンピューターのソフトウェア、ハードウェア、通信機器の機能を妨害、破壊、制限するように設計されたコンピューターウィルス、コンピューターコード、ファイル、プログラム等のコンテンツを本サービスにアップロードしたり、メール等の手段で送信したりする行為',
            ARTICLE14_DESCRIPTION11: '(10) 同一会員が複数の会員登録をおこなう行為（パソコン、携帯電話又はスマートフォン何れから複数登録する行為も含むものとします。但し、当社が予め認めたものは除きます。',
            ARTICLE14_DESCRIPTION12: '(11) 過度に商品を返品する行為',
            ARTICLE14_DESCRIPTION13: '(12) その他当社の信用を毀損・失墜させる等の当社が不適当であると合理的に判断する行為',
            ARTICLE15: '第第15条 知的財産権',
            ARTICLE15_DESCRIPTION1: '1. 本サービスを通じて提供されるコンテンツの知的財産権は、全て当社に専属的に帰属するものとします。',
            ARTICLE15_DESCRIPTION2: '2. 目的の如何を問わず、当社のコンテンツの無断複製、無断転載その他の無断二次利用行為等の国内及び国外の著作権法及びその他の法令により禁止される行為が発見された場合には、当社は直ちに法的措置をとるものとします。',
            ARTICLE15_DESCRIPTION3: '3. 本条の規定に違反して第三者との間で何らかの紛争が生じた場合、会員はその責任と費用において、かかる紛争を解決するとともに、当社に何らの損害、損失又は不利益等を与えないものとします。',
            CHAPTER5: '第5章 サービスの運用',
            ARTICLE16: '第16条 情報の管理',
            ARTICLE16_DESCRIPTION1: '1. 当社は、その裁量により、当社及び当社と提携するサイトにおいて、本サービスに関連して利用者が発信したコンテンツの全部又は一部を自由に利用できるものとします。当該コンテンツを利用するにあたり、当社は投稿者に対して一切の支払を必要としないものとします。',
            ARTICLE16_DESCRIPTION2: '2. 当社は利用者のアクセス履歴及び利用状況の調査のため、又は利用者へのサービス向上のために利用者のアクセス履歴に関する以下の情報を収集します。なお、当社が発行するクッキーは効果的な広告配信の目的等に使用し、個人情報の収集やその他の目的には一切使用致しません。',
            ARTICLE16_DESCRIPTION3: '(1) 利用者が本サービスのサーバーにアクセスする際のIPアドレス又は携帯端末の機体識別番号に関する情報',
            ARTICLE16_DESCRIPTION4: '(2) 当社が、クッキーの技術（Webブラウザを通じてユーザーのコンピューターに一時的にデータを書き込んで利用者が最後にサイトを訪れた日時、そのサイトの訪問回数等を記録保存する技術をいいます。）を通じて取得する利用者のアクセス情報',
            ARTICLE16_DESCRIPTION5: '3. 利用者は、利用者がWebブラウザでクッキーを拒否するための設定を行った場合、本サービスの利用が制限される場合があることを予め了承するものとします。',
            ARTICLE17: '第17条 本サービスの保守',
            ARTICLE17_DESCRIPTION1: '当社は、本サービスの稼動状態を良好に保つため、以下各号の何れかの場合には、 利用者に事前に通知を行うことなく、一時的に本サービスの提供の全部又は一部を停止又は中止することができるものとします。',
            ARTICLE17_DESCRIPTION2: '(1) 本サービス提供のためのコンピューターシステム（以下、「システム」といいます。）の定期保守及び緊急保守の場合',
            ARTICLE17_DESCRIPTION3: '(2) 火災、地震、洪水、落雷、大雪等の天変地異により、システムの運用が困難になった場合',
            ARTICLE17_DESCRIPTION4: '(3) 戦争、内乱、テロ、暴動、騒擾等の社会不安により、システムの運用が困難になった場合',
            ARTICLE17_DESCRIPTION5: '(4) システムの不良及び第三者からの不正アクセス、コンピューターウィルスの感染等により、システムの運用が困難になった場合',
            ARTICLE17_DESCRIPTION6: '(5) 政機関・司法機関から相当な根拠に基づき要請された場合',
            ARTICLE17_DESCRIPTION7: '(6) その他やむを得ずシステムの停止又は中止が必要と当社が判断した場合',
            ARTICLE18: '第18条 その他',
            ARTICLE18_DESCRIPTION1: '1. 本サービスの利用に関して、本規約又は当社の指導・対応により解決できない問題が生じた場合には、当社と利用者との間で双方誠意をもって話し合い、これを解決するものとします。',
            ARTICLE18_DESCRIPTION2: '2. 本サービスの利用に関して訴訟の必要が発生した場合には、名古屋地方裁判所を第一審の専属合意管轄裁判所にするものとします。',
            ARTICLE18_DESCRIPTION3: '付則：本規約は2018年11月21日から全ての利用者に適用されるものとします。',
            ORDERGO_TITLE: 'Order Go!サービス利用規約',
            ORDERGO_CHAPTER1: '第1章 総則',
            ORDERGO_ARTICLE1: '第1条 本規約の範囲及び変更',
            ORDERGO_ARTICLE1_DESCRIPTION1: '1. この規約（以下、「本規約」といいます。）は、当社が運営するウェブサイト「Order Go!」に関するサービス（以下、「本サービス」といいます。）の利用に関し、当社及び会員（第3条で定義します。）に適用されるものとします。但し、本サービス以外に当社が提供する各サービスに関しては、当該各サービスに関連する利用規約のみが適用されるものとします。',
            ORDERGO_ARTICLE1_DESCRIPTION2: '2. 当社は、会員の事前の承諾を得ることなく、ウェブサイト上での掲載又はメール等の当社が適当と判断する方法で会員に告知又は通知することにより、適宜、本規約の全部又は一部を変更できるものとします。',
            ORDERGO_ARTICLE1_DESCRIPTION3: '3. 本規約の全部又は一部が変更された場合、本サービスの利用に関しては、変更後の規約のみが適用されるものとし、会員は変更後の規約のみに従うものとします。',
            ORDERGO_ARTICLE2: '第2条 本サービスの利用',
            ORDERGO_ARTICLE2_DESCRIPTION1: '1. 会員は、法令、条例、規則、通達並びに共通サービス利用規約、本規約及び当社が別途定める個人情報保護方針、ヘルプ等に従い、本サービスを利用するものとします。',
            ORDERGO_ARTICLE2_DESCRIPTION2: '2. 未成年の会員は、適格な法定代理人の事前の同意を得なければ、本サービスを利用することができません。',
            ORDERGO_ARTICLE3: '第3条 提供するサービス',
            ORDERGO_ARTICLE3_DESCRIPTION1: '利用者は、本サービスにおいて次の行為を行うことができます。',
            ORDERGO_ARTICLE3_DESCRIPTION2: '(1) 会員は、当社所定の方法に従い、本サービスを利用して当社から商品等を購入する、キャラクター、背景、AIサービス等の設定をすることができます。',
            ORDERGO_CHAPTER2: '第2章 会員',
            ORDERGO_ARTICLE4: '第4条 会員',
            ORDERGO_ARTICLE4_DESCRIPTION1: '本規約において「会員」とは、当社が別途定める＜共通サービス利用規約＞「第4条 会員」の規定が適用されるものとします。',
            ORDERGO_ARTICLE5: '第5条 会員登録',
            ORDERGO_ARTICLE5_DESCRIPTION1: '1. 会員登録をする際には、＜共通サービス利用規約＞「第5条 会員登録」に定めた会員登録に必要な項目を入力・設定した上で、登録申請することを前提条件とします。',
            ORDERGO_ARTICLE5_DESCRIPTION2: '2. 未成年者は、適格な法定代理人の事前の同意がなければ、会員登録申請をすることができないものとします。',
            ORDERGO_ARTICLE5_DESCRIPTION3: '3. 当社は、以下の各号の何れかに該当する場合、当該登録を承認しない場合があります。',
            ORDERGO_ARTICLE5_DESCRIPTION4: '(1)会員登録の希望者が過去に当社の提供する何らかのサービスに関する規約（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）に違反したこと等により、会員登録の抹消等の処分を受けていたことが判明した場合',
            ORDERGO_ARTICLE5_DESCRIPTION5: '(2)会員登録の希望者の申請内容に虚偽の事項が含まれていることが判明した場合',
            ORDERGO_ARTICLE5_DESCRIPTION6: '(3)過去に当社の提供する何らかのサービス（サイト上に明記した各サービスに関連する他社のサービスを含みますが、これらに限りません。）に関して、料金等の支払を履行していない場合（当社が別途認める支払方法に関連する第三者に対して料金等の支払を履行していない場合を含みますが、これに限りません。）、又は、正当な理由なく長期間に亘る商品又はサービス（以下、「商品等」と総称します。）の受取り不能、返品・交換の拒絶その他の債務不履行があったことが判明した場合',
            ORDERGO_ARTICLE5_DESCRIPTION7: '(4)過去に＜共通サービス利用規約＞「第14条 禁止事項」の行為を行ったことが判明した場合',
            ORDERGO_ARTICLE5_DESCRIPTION8: '(5)その他登録を承認することが本サービスの運営・管理上、不適当であると当社が合理的に判断する場合',
            ORDERGO_ARTICLE6: '第6条 登録内容の変更',
            ORDERGO_ARTICLE6_DESCRIPTION1: '1. 会員は、氏名、住所、電話番号その他当社に登録している事項の全部又は一部に変更が生じた場合には、当社が指定する方法により、すみやかに登録内容を変更するものとします。',
            ORDERGO_ARTICLE6_DESCRIPTION2: '2. 当社は、会員が適宜、変更登録を行わなかったことにより何らかの損害が生じたとしても、一切責任を負わないものとします。',
            ORDERGO_ARTICLE7: '第7条 本サービスの利用停止及び会員登録の取消',
            ORDERGO_ARTICLE7_DESCRIPTION1: '当社は、会員が以下の各号の何れかに該当する場合、事前通知することなく、当該会員に対して本サービスの利用停止、会員登録抹消その他当社が適当と考える措置を講ずることができるものとします。',
            ORDERGO_ARTICLE7_DESCRIPTION2: '(1)過去に当社の提供する何らかのサービスに関する規約（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）に違反をしたこと等により、会員登録の抹消等の処分を受けていたことが判明した場合',
            ORDERGO_ARTICLE7_DESCRIPTION3: '(2)登録された内容に虚偽の事項が含まれていることが判明した場合',
            ORDERGO_ARTICLE7_DESCRIPTION4: '(3)過去又は現在において、当社の提供する何らかのサービス（サイト上に明記した各サービスに関連する他社のサービスを含みますが、これらに限りません。）に関して、料金等の支払を履行していない場合（当社が別途認める支払方法に関連する第三者に対して料金等の支払を履行していない場合を含みますが、これに限りません。）、又は、正当な理由なく長期間に亘る商品等の受取り不能、返品・交換の拒絶その他の債務不履行があったことが判明した場合',
            ORDERGO_ARTICLE7_DESCRIPTION5: '(4)＜共通サービス利用規約＞「第14条禁止事項」の行為を行ったことが判明した場合',
            ORDERGO_ARTICLE7_DESCRIPTION6: '(5)その他当社の定める何らかの規約（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）に違反した場合',
            ORDERGO_ARTICLE8: '第8条 退会手続',
            ORDERGO_ARTICLE8_DESCRIPTION1: '退会を希望する場合は、別途定める＜共通サービス利用規約＞「第8条 退会手続」の規定が適用されるものとします。',
            ORDERGO_CHAPTER3: '第3章 商品の購入',
            ORDERGO_ARTICLE9: '第9条 商品の購入',
            ORDERGO_ARTICLE9_DESCRIPTION1: '1. 会員は、商品等の購入を希望する場合、当社が別途指定する方法に従って、商品等の購入又は利用を申込むものとします。',
            ORDERGO_ARTICLE9_DESCRIPTION2: '2. 前項の申込みに伴い、会員が入力・登録した注文内容等を確認の上で注文する旨のボタンをクリックし、その後、当社から注文内容を確認する旨のメールが会員に到達した時点で、会員と当社との間に当該商品等に関する売買契約が成立するものとします。',
            ORDERGO_ARTICLE9_DESCRIPTION3: '3. 前項の規定に拘わらず、本サービス利用に関して不正行為又は不適当な行為があった場合、当社は売買契約について取消、解除その他の適切な措置を取ることができるものとします。',
            ORDERGO_ARTICLE10: '第10条 支払方法',
            ORDERGO_ARTICLE10_DESCRIPTION1: '1. 商品等の支払い金額は、消費税を含む商品等の購入代金及びこれに係わる取り扱い手数料の合計となります。',
            ORDERGO_ARTICLE10_DESCRIPTION2: '2. 本サービスによって購入された商品等の支払いに関しては、会員本人名義のクレジットカードによる支払、又は当社が別途認める支払方法に限るものとします。',
            ORDERGO_ARTICLE10_DESCRIPTION3: '3. クレジットカードで支払われる場合は、会員がクレジットカード会社との間で別途契約する条件に従うものとします。なお、クレジットカードの利用に関連して、会員とクレジットカード会社等の間で何らかの紛争が発生した場合は、会員とクレジットカード会社との間で責任をもって解決するものとします。',
            ORDERGO_ARTICLE11: '第11条 商品等の返品・交換・注文の撤回及び取消し',
            ORDERGO_ARTICLE11_DESCRIPTION1: '1.ご注文の撤回及び取消しについては、当社の責めに帰すべき事由がある場合を除き、商品のご注文の撤回および取消しをすることができません。',
            ORDERGO_ARTICLE11_DESCRIPTION2: '2.商品の返品については、以下の場合に限り受け付けるものとします。',
            ORDERGO_ARTICLE11_DESCRIPTION3: '(1)商品が模造品・海賊版であることが判明した場合',
            ORDERGO_ARTICLE11_DESCRIPTION4: '(2)商品に瑕疵があった場合',
            ORDERGO_ARTICLE12: '第12条 商品等に関する免責',
            ORDERGO_ARTICLE12_DESCRIPTION1: '1.当社は、本サービス及び本サービスを通じて販売される商品等につき、その品質、材質、機能、性能、プログラム、他の商品との適合性その他の欠陥、又はこれらが原因となり生じた損害、損失、不利益等については、前条に定める場合を除き、いかなる保証・負担も負わないものとします。',
            ORDERGO_ARTICLE12_DESCRIPTION2: '2.当社は、Order Go!のすべてのサービス及びトップページ及び販売ページ上において、Twitter等のSNSサービスの利用会員が投稿した商品及び設定に関するコメントの内容について、当該コメントの内容が事実に反するものであったとしても、これによる商品を購入した会員に生じた損害に対しては、当社に故意又は重過失がある場合を除き、一切の責任を負わないものとします。',
            ORDERGO_ARTICLE12_DESCRIPTION3: '付則：本規約は2018年11月29日から全ての会員に適用されるものとします。',
        },
        LATEST_CHANGES: {
            ADD_PROJECT: '{{projectName}} - {{fullname}} vừa thêm {{subject}} dự án',
            UPDATE_PROJECT: '{{projectName}} - {{fullname}} chỉnh sửa {{subject}} dự án',
            UPDATE_PROJECT_BY_CLIENT: '{{projectName}} - {{fullname}} chỉnh sửa {{subject}} dự án',
            DELETE_PROJECT: '{{projectName}} - {{fullname}} vừa xóa {{subject}} dự án',
            ADD_CONVERSATION: '{{projectName}} - {{fullname}} vừa thêm {{subject}} nhóm chat',
            UPDATE_CONVERSATION: '{{projectName}} - {{fullname}} vừa chỉnh sửa {{subject}} nhóm chat',
            DELETE_CONVERSATION: '{{projectName}} - {{fullname}} vừa xóa {{subject}} nhóm chat',
            ADD_MESSAGE: '{{projectName}} - {{fullname}}さんが新しいメッセージを追加しました',
            UPDATE_MESSAGE: '{{projectName}} - {{fullname}}さんがメッセージを更新しました',
            DELETE_MESSAGE: '{{projectName}} - {{fullname}}さんがメッセージを削除しました',
            UNREAD: 'Chưa đọc'
        },
        GANTT_CHART: {
            TITLE: 'Lịch dự án ',
            ADD_TASK_BUTTON: 'Thêm công việc',
            UPDATE_TASK: 'Cập nhật công việc',
            ADD_TASK: 'Thêm công việc',
            SUBJECT: 'Tên công việc',
            SUBJECT_ERROR: 'Lỗi tên công việc',
            FROM_DATE: 'Ngày bắt đầu',
            FROM_DATE_ERROR: 'Lỗi ngày bắt đầu',
            TO_DATE: 'Ngày kết thúc',
            TO_DATE_ERROR: 'Lỗi ngày kết thúc',
            COLOR: 'Màu',
            RED_COLOR: 'Đỏ',
            BLUE_COLOR: 'Xanh',
            PRIORITY: 'sự ưu tiên',
            SEND_SCHEDULE_BUTTON: 'send schedule',
            SEND_SCHEDULE_BUTTON_MOBILE: 'send',
            ADD_TASK_BUTTON_MOBILE: 'task',
        },
        LIBRARY:{
            TITLE: 'Library',
            FILE_NAME: 'File Name',
            ADD: 'Add',
            EDIT: 'EDIT',
            DELETE: 'Delete',
            TAGS: 'Tags',
            ADD_NEW_TAG: 'Add New Tag',
            SEARCH_BY_TAGS: 'Search by Tag',
            SEARCH_BY_MATERIAL: 'Search by Material',
            SEARCH_BY_COLOR: 'Search by Color',
            UPLOAD_FILE_FROM_OUTSIDE: 'Upload File',
            SELECT_TAGS: 'Select Tags',
            SELECT_COLORS: 'Select Colors',
            LIST_OF_MATERIALS: 'List of Materials'
        },
        PUSH_NOTIFICATION: {
            PROJECT_MODIFIED_TITLE: 'Dự án sửa đổi',
            PROJECT_MODIFIED_BODY: '{{fullname}} đã sửa đổi Dự án {{name}}.',
            CONVERSATION_MODIFIED_TITLE: 'Nhóm trò chuyện đã sửa đổi',
            CONVERSATION_MODIFIED_BODY: '{{fullname}} đã sửa đổi {{name}} Nhóm trò chuyện.',
            MESSAGE_ADDED_TITLE: 'Tin nhắn mới',
            MESSAGE_ADDED_BODY: '{{fullname}} đã gửi một tin nhắn mới tới {{name}}',
            DIRECT_MESSAGE_ADDED_BODY: 'Tin nhắn mới nhận được từ {{fullname}}',
            NOTIFICATION_TITLE: 'Thông báo',
            NOTIFICATION_TEXT: 'Thông báo đang chờ bạn.',
        },
        FILE_ANNOTATIONS: {
            RECTANGLE_TOOL: 'Rectangle tool',
            CIRCLE_TOOL: 'Circle tool',
            ARROW_TOOL: 'Arrow tool',
            POLYGON_TOOL: 'Polygon tool',
            PAINT_TOOL: 'Paint tool',
            ANNOTATION_TOOL: 'Annotation tool',
            SAVE_AND_SEND: 'Save and send',
            SAVE_AND_CLOSE: 'Save and close',
            CLOSE_WITHOUT_SAVE: 'Close without save',
            ANGLE: "Angle",
            SAVE: "Save",
            ADD: "Add",
            RESTORE: 'Restore',
            ADD_COMMENT: "Add comment",
            PERSPECTIVE_CORRECTION: "Perspective correction",
            DOWNLOAD_ANNOTATED_IMAGE: "Download annotated image",
            DOWNLOAD_ORIGINAL_IMAGE: "Download original image",
            DELETE: 'Delete',
            UNDO: 'Undo',
            REDO: 'Redo',
            RESIZE: 'Resize',
            DOWNLOAD: 'Download',
            DISPLAY_HORIZONTAL: 'Display horizontal',
            DISPLAY_VERTICAL: 'Display vertical',
            DESCRIPTION: '<p>You can check back directly from here.</p><p>*Number the figure and add a comment.</p><p>※You can also enter shapes and arrows.</p>',
        }
    }
};
